export default __webpack_public_path__ + "static/media/ressence.f8f632a8.jpg";